<template>
    <div class="accessory-card storage-card">
        <div class="accessory-image">
            <img :src="productImage" class="img-responsive">
        </div>
        <div class="accessory-content">
            <h6 class="accessory-title">{{ selectedDrive.name }}</h6>
            <p class="accessory-description">
                {{ selectedDrive.description }}
            </p>
        </div>
        <div class="accessory-footer">
            <multiselect
                v-model="selectedDrive"
                :allow-empty="false"
                :class="{ 'disable-element': isUpdating }"
                :internal-search="false"
                :options="storage"
                :searchable="false"
                :show-labels="false"
                label="title"
                track-by="id"
                @input="changeStorage"
            >
                <template slot="singleLabel" slot-scope="props">
                    {{ props.option.variants[0].capacity | formatCapacity }}
                </template>
                <template slot="option" slot-scope="props">
                    {{ props.option.variants[0].capacity | formatCapacity }}
                </template>
            </multiselect>
            <p class="accessory-price">{{ selectedDrive.variants[0].price | formatMoney }}</p>
        </div>

        <button
            v-if="!selectedStorage.id"
            :class="{ 'disable-element': isUpdating }"
            :disabled="isUpdating"
            type="button"
            class="btn btn-block add-to-cart"
            @click="addStorage()"
        >
            ADD TO CART
        </button>
        <button
            v-else
            :class="{ 'disable-element': isUpdating }"
            :disabled="isUpdating"
            type="button"
            class="btn btn-block btn-purple btn-outline remove-from-cart"
            @click="removeStorage()"
        >
            REMOVE FROM CART
        </button>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import _cloneDeep from "lodash/cloneDeep";

export default {
    name: "StorageCard",
    filters: {
        formatCapacity(value) {
            const capacity = value.split(" ");

            return Number.parseInt(capacity[0]) + capacity[1];
        }
    },
    props: {
        selectedStorage: {
            type: Object,
            required: true
        },
        storage: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            selectedDrive: null
        }
    },
    created() {
        this.selectedDrive = this.selectedStorage.id != 0 && _cloneDeep(this.selectedStorage) || _cloneDeep(this.storage[0]);
    },
    computed: {
        ...mapState({
            externalStorageEmpty: state => state.StarterPc.externalStorageEmpty,
            isUpdating: state => state.StarterPc.isUpdating
        }),
        productImage() {
            const marketingImage = this.selectedDrive.images_marketing &&
                this.selectedDrive.images_marketing[0].image_url;

            const defaultImage = this.selectedDrive.images_cover &&
                this.selectedDrive.images_cover[0].image_url;

            return marketingImage || defaultImage;
        }
    },
    methods: {
        ...mapActions({
            removePart: "StarterPc/removePart",
            setSelectedStorage: "StarterPc/setSelectedStorage",
            updatePart: "StarterPc/updatePart"
        }),
        addStorage() {
            this.updatePart({ part: this.selectedDrive.variants[0], qty: 1 }).then(() => {
                this.setSelectedStorage(this.selectedDrive);
            });
        },
        changeStorage(storage) {
            if (this.selectedStorage.id != 0) {
                if (this.selectedStorage.variants[0].products_id == storage.variants[0].products_id) {
                    this.updatePart({ part: storage.variants[0], qty: 1 }).then(() => {
                        this.setSelectedStorage(storage);
                    });
                } else {
                    this.removePart(this.selectedStorage.variants[0]).then(() => {
                        this.updatePart({ part: storage.variants[0], qty: 1 }).then(() => {
                            this.setSelectedStorage(storage);
                        });
                    });
                }
            }
        },
        removeStorage() {
            this.removePart(this.selectedStorage.variants[0]).then(() => {
                this.setSelectedStorage(this.externalStorageEmpty);
                this.selectedDrive = _cloneDeep(this.storage[0]);
            });
        }
    }
}
</script>

<style lang="scss" scoped>
@import "./accessory-style";
</style>

<style lang="scss">
@import "./multiselect-style";

.storage-card {
    .multiselect {
        width: 34%;
    }
}
</style>
